// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	$w("#TerreArmeeLogo").show();
	$w("#YezumLogo").hide();
	$w("#TaasiotLogo").hide();
	$w("#group2").hide();
	$w("#image10").hide();
	$w("#box3").hide();

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});